import { useFormikContext } from "formik";
const useReportForm = () => useFormikContext();
export default useReportForm;
